import { UrlSegment } from '@angular/router';

/**
 * Copies matrix params, such as a list's page and sort, from `segments` while `commands` follows the URL
 * segment by segment.  Commands from the first one that leaves the URL on are passed through unchanged.
 */
export function withUrlSegmentParams(commands: any[], segments: UrlSegment[]): any[] {
  const firstUnmatched = commands.findIndex((command, i) => command !== segments[i]?.path);
  const matchedCount = firstUnmatched === -1 ? commands.length : firstUnmatched;

  return [
    ...segments.slice(0, matchedCount).flatMap(segment =>
      Object.keys(segment.parameters).length > 0 ? [ segment.path, segment.parameters ] : [ segment.path ]),
    ...commands.slice(matchedCount),
  ];
}
